import React from 'react';

function Bypass({id,emit}) {
  return (
    <></>
  );
}

export default Bypass;
